export const getFinancingTypeFilter = state => state.financing.financingModalProduct.filter
